import {CountAmenityType} from "@CheckOrder/features/amenities/features/countAmenity/types/CountAmenity.type";
import {
    CountAmenitySelectedType
} from "@CheckOrder/features/amenities/features/countAmenity/types/CountAmenitySelected.type";
import {SetStateType} from "@/types/generic/SetState.type";

export default function useCountAmenity(
    countAmenity: CountAmenityType,
    selectedAmenities: Record<string, CountAmenitySelectedType>,
    setSelectedAmenities: SetStateType<Record<string, CountAmenitySelectedType>>
) {
    const {
        min,
        max,
        key,
        price,
        type,
    } = countAmenity

    const value = selectedAmenities[key]?.value ?? min

    const handleIncrement = () => {
        if (value + 1 <= max) {
            setSelectedAmenities((prevSelectedAmenities) => ({
                ...prevSelectedAmenities,
                [key]: {
                    key,
                    price,
                    value: value + 1,
                    type,
                },
            }))
        }
    }

    const handleDecrement = () => {
        if (value - 1 >= min) {
            setSelectedAmenities((prevSelectedAmenities) => ({
                ...prevSelectedAmenities,
                [key]: {
                    key,
                    price,
                    value: value - 1,
                    type,
                },
            }))
        }
    }

    return {
        value,
        handleIncrement,
        handleDecrement,
    }
}